module.exports = __webpack_public_path__ + "img/member_keep_02.532c16f6.png";